import { useContext } from 'react';
import EditSessionContext from './EditSessionContext';
export default function useEditSession(isEditSessionActive) {
    const context = useContext(EditSessionContext);
    return isEditSessionActive === undefined
        ? context
        : { ...context, isEditSessionActive };
}
